<template>
    <div id="app" :class="[this.$store.state.nightMode ? 'dark' : '', { 'bp-cartbar-on': showCartBar, 'bp-nocart': noCartPanel }]">
        <!-- Видно лише тому, хто відкрив демо нового дизайну (?v2); клік повертає звичайний сайт -->
        <a v-if="$v2" class="bp-v2-badge" href="?v2=0" title="Повернути звичайний вигляд сайту">Новий дизайн · демо <span aria-hidden="true">×</span></a>
        <InfoModal
            v-if="showInfoModal"
            v-on:close="closeInfomationModal()"
            :info="infoModalText"
            :isApplication="isApplication"
            :applicationType="applicationType"
            :applicationURL="applicationURL"
        />

        <!-- Новий дизайн: сайт закритий — табличка «Зачинено» замість вікна -->
        <ClosedSign v-if="$v2 && showClosedSign"
                    :title="closedTitle"
                    :text="closedText"
                    :dark="!!$store.state.nightMode"
                    @close="showClosedSign = false"
        />

        <LocationCityModal v-if="isShowLocationCityModal"
                           v-on:close="closeLocationCityModal"
                           :changeLocationCity="changeLocationCity"
                           :locationCities="locationCities"
                           :isApplication="isApplication"
                           :applicationType="applicationType"
                           :applicationURL="applicationURL"
        />

        <div v-if="mobNav">
            <div class="mob-nav-overlay" @click="closeMobNav()"></div>
            <div class="mob-nav">
                <div style="font-weight: bold;font-size: 1.4rem;padding-left: 14px;padding-right: 14px;">
                    <div style="text-align: left;margin-right: 14px;">
                        <ul style="list-style: none;padding: 0;font-weight: bold;">
                            <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('pizza')"><span v-if="$v2" class="bp-mnav-ic" v-html="icons.home"></span>Головна</li>
                            <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('delivery-map')"><span v-if="$v2" class="bp-mnav-ic" v-html="icons.map"></span>Мапа доставки</li>
                            <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('about-us')"><span v-if="$v2" class="bp-mnav-ic" v-html="icons.info"></span>Про нас</li>
                            <li v-if="$v2 && features.whoPays" style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('who-pays')"><span class="bp-mnav-ic" v-html="icons.dice"></span>Хто платить?</li>
                            <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('offer')"><span v-if="$v2" class="bp-mnav-ic" v-html="icons.doc"></span>Угода
                                користувача
                            </li>
                            <!-- «Співпраця» закрита з 03.11 на прохання власника; повернути — розкоментувати пункт і зняти beforeEnter у router.js -->
                        </ul>
                    </div>
                </div>
                <!-- Новий дизайн: контакти одразу в меню — адреса з маршрутом, години і чи зараз працюємо (телефон уже в шапці, не дублюємо) -->
                <div v-if="$v2" class="bp-mnav-contacts">
                    <a class="bp-mnav-row" :href="'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent($store.state.address)" target="_blank" rel="noopener"><span class="bp-mnav-ic" v-html="icons.pin"></span><span>{{ $store.state.address }}</span></a>
                    <div class="bp-mnav-row"><span class="bp-mnav-ic" v-html="icons.clock"></span><span>11:00–22:00</span><i class="bp-hstatus__dot" :class="openStatus.open ? 'is-open' : 'is-closed'" aria-hidden="true"></i><span class="bp-mnav-status">{{ openStatus.word }}</span></div>
                </div>
                <div :class="{ 'bp-mnav-apps-t': $v2 }" style="
padding: 10px 0 4px;
font-size: 1.2rem;
font-weight: bold;
">
                    Завантажуй додаток:
                </div>
                <div style="display: flex; justify-content: center; gap: 4px">
                    <a href="https://apps.apple.com/cy/app/black-pizza/id1498371417" target="_blank" rel="nofollow"
                       aria-label="App Store" style="display: inline-block; margin: 4px 0 4px 4px"
                       onclick="dataLayer.push({'event': 'clickAppStore'});">
                        <img src="@/assets/appstore.webp" style="width: 120px;" alt="App Store" title="App Store">
                    </a>

                    <a href="https://play.google.com/store/apps/details?id=com.oakmont.blackpizza" target="_blank"
                       rel="nofollow" aria-label="Google Play" style="display: inline-block; margin: 4px 0 4px 4px"
                       onclick="dataLayer.push({'event': 'clickGooglePlay'});">
                        <img src="@/assets/googleplay.webp" style="width: 120px;" alt="Google Play" title="Google Play">
                    </a>
                </div>

                <!-- Новий дизайн, телефон: мітка «демо» тут, а не плаває над сторінкою — там вона закривала ціни й назви -->
                <a v-if="$v2" class="bp-mnav-demo" href="?v2=0" title="Повернути звичайний вигляд сайту">Новий дизайн · демо <span aria-hidden="true">×</span></a>

                <!-- Новий дизайн: перемикач теми в шапці телефона (.bp-mtheme), у меню не дублюємо -->
                <div v-if="!$v2" class="night-mode-checkbox" style="display: flex; justify-content: center;margin-top: 26px">
                    <input type="checkbox" class="checkbox" id="toggleBtn" @change="changeMode" v-model="!!this.$store.state.nightMode"/>
                    <label class="switch" for="toggleBtn">
                        <inline-svg src="/img/icons/sun.svg" class="icon fa-sun" width="25" height="25" ></inline-svg>
                        <inline-svg src="/img/icons/moon.svg" class="icon fa-moon" width="25" height="25"></inline-svg>
                        <div class="ball"></div>
                    </label>
                </div>
            </div>
        </div>

        <div class="main-overlay" id="main-overlay" ref="main-overlay"></div>
        <header>
            <div style="display: flex;justify-content: space-between;width: 100%;align-items: center;">
                <div class="info-section-mobile">
                    <div style="margin-right: 14px; display: flex; align-items: center; justify-content: center">
                        <!-- Новий дизайн: «бутерброд» — три товсті короткі лінії (варіант «В» власника, 03.11) -->
                        <button v-if="!mobNav && $v2" type="button" class="bp-mclose bp-mburger" aria-label="Відкрити меню" @click="showMobNav()" v-html="icons.menu"></button>
                        <inline-svg v-else-if="!mobNav" @click="showMobNav()" src="/img/icons/hamburger-menu.svg" width="25" height="25" :stroke="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>

                        <!-- Новий дизайн: закрити меню — простий «×» без квадрата, як «бутерброд» -->
                        <button v-if="mobNav && $v2" type="button" class="bp-mclose" aria-label="Закрити меню" @click="closeMobNav()" v-html="icons.close"></button>
                        <inline-svg v-else-if="mobNav" @click="closeMobNav()" src="/img/icons/close-box.svg" width="25" height="25" :fill="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                    </div>

                    <router-link :to="{name: 'pizza', params: {locationCity: this.$route.params.locationCity}}" :params="{ locationCity: this.$route.params.locationCity }" v-if="!this.$store.state.nightMode">
                        <img src="@/assets/logo_site.webp" class="logo-image" style="width: 250px;">
                        <img src="@/assets/logo_site_mob.webp" class="logo-image-mobile" style="width: 36px;">
                    </router-link>

                    <router-link :to="{name: 'pizza', params: {locationCity: this.$route.params.locationCity}}" :params="{ locationCity: this.$route.params.locationCity }" v-if="this.$store.state.nightMode">
                        <img src="@/assets/logo_site_white.webp" class="logo-image" style="width: 250px;">
                        <img src="@/assets/logo_symbol_white.webp" class="logo-image-mobile" style="width: 36px;">
                    </router-link>
                </div>

                <div style="display: flex;align-items: center;">
                    <div class="info-section">
                        <router-link :to="{name: 'pizza', params: {locationCity: this.$route.params.locationCity}}" :params="{ locationCity: this.$route.params.locationCity }" v-if="!this.$store.state.nightMode">
                            <img src="@/assets/logo_site.webp" class="logo-image" style="width: 250px;">
                            <img src="@/assets/logo_site_mob.webp" class="logo-image-mobile" style="width: 61px;">
                        </router-link>

                        <router-link :to="{name: 'pizza', params: {locationCity: this.$route.params.locationCity}}" :params="{ locationCity: this.$route.params.locationCity }" v-if="this.$store.state.nightMode">
                            <img src="@/assets/logo_site_white.webp" class="logo-image" style="width: 250px;">
                            <img src="@/assets/logo_symbol_white.webp" class="logo-image-mobile" style="width: 61px;">
                        </router-link>

                        <!-- Новий дизайн: Instagram лише в підвалі (там і решта соцмереж), у шапці — тільки дії -->
                        <div v-if="!$v2" style="display: flex;margin-right: 14px; margin-left: 14px"
                             onClick="window.open('https://www.instagram.com/black_pizza/')">
                            <inline-svg src="/img/icons/instagram.svg" width="25" height="25"
                                        fill="#AB2321"></inline-svg>
                            <div style="margin-left: 7px;">
                                <span style="font-weight: bold;">/black_pizza</span>
                            </div>
                        </div>

                        <div style="display: flex;margin-right: 14px;cursor: pointer" @click="showLocationCityModal()">
                            <inline-svg src="/img/icons/map-point.svg" width="25" height="25" stroke="#AB2321"></inline-svg>
                            <div style="margin-left: 7px;">
                                <span style="font-weight: bold;">{{ this.$store.state.address }}</span>
                            </div>
                        </div>

                        <a v-if="$v2" class="bp-hcall" :href="'tel:' + $store.state.phone" aria-label="Подзвонити">
                            <span class="bp-hcall__ic" v-html="icons.phone"></span><span>{{ $store.state.phone }}</span>
                        </a>
                        <div v-else style="margin-right: 14px;display: flex;">
                            <inline-svg src="/img/icons/phone-2.svg" width="25" height="25" stroke="#AB2321"></inline-svg>
                            <div style="margin-left: 7px;font-weight: bold;">{{ this.$store.state.phone }}</div>
                        </div>

                        <!-- Новий дизайн: «● Працюємо / Зачинено» (зелена крапка пульсує, червона — ні), далі годинник і години роботи -->
                        <div v-if="$v2" class="bp-hstatus" role="status" :aria-label="openStatus.text" :title="openStatus.text">
                            <i class="bp-hstatus__dot" :class="openStatus.open ? 'is-open' : 'is-closed'" aria-hidden="true"></i>
                            <span class="bp-hstatus__word" aria-hidden="true">{{ openStatus.word }}</span>
                            <span class="bp-hstatus__ic" v-html="icons.clock" aria-hidden="true"></span>
                            <span aria-hidden="true">11:00–22:00</span>
                        </div>
                        <div v-else style="display: flex;margin-right: 14px;">
                            <inline-svg src="/img/icons/clock.svg" width="25" height="25"
                                        fill="#AB2321"></inline-svg>
                            <div style="margin-left: 7px;">
                                <span style="font-weight: bold;">11:00-22:00</span>
                            </div>
                        </div>

                        <!-- Новий дизайн: на «Мапі доставки», «Про нас» і «Угоді» бокової панелі кошика немає — кошик тут, у шапці -->
                        <router-link v-if="noCartPanel" class="bp-hcircle bp-hcart" :class="{ 'bp-bump': cartBump }" :to="{name: 'cart', params: {locationCity: $route.params.locationCity}}"
                                     :aria-label="$store.getters.cartCount ? 'Кошик: ' + $store.getters.cartCount + ' ' + cartCountWord : 'Кошик'" title="Кошик">
                            <inline-svg src="/img/icons/shopping-cart.svg" width="22" height="22" fill="currentColor" aria-hidden="true"></inline-svg>
                            <span v-if="$store.getters.cartCount > 0" class="cart-badge">{{ $store.getters.cartCount }}</span>
                        </router-link>
                        <!-- Новий дизайн: тема — кругла сіра кнопка, як у шапці телефона (зразок власника — Ninja Pizza) -->
                        <button v-if="$v2" type="button" class="bp-hcircle bp-htheme" @click="changeMode()" v-html="$store.state.nightMode ? icons.sun : icons.moon"
                                :aria-label="$store.state.nightMode ? 'Увімкнути світлу тему' : 'Увімкнути темну тему'" :title="$store.state.nightMode ? 'Світла тема' : 'Темна тема'"></button>
                        <div v-else class="night-mode-checkbox">
                            <input type="checkbox" class="checkbox" id="toggleBtn" @change="changeMode" v-model="!!this.$store.state.nightMode"/>
                            <label class="switch" for="toggleBtn">
                                <inline-svg src="/img/icons/sun.svg" class="icon fa-sun" width="25" height="25" ></inline-svg>
                                <inline-svg src="/img/icons/moon.svg" class="icon fa-moon" width="25" height="25"></inline-svg>
                                <div class="ball"></div>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="info-section-mobile">
                    <div style="margin-right: 14px" @click="showLocationCityModal()">
                        <inline-svg src="/img/icons/map-point.svg" width="25" height="25" :stroke="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                        <b style="margin-left: 4px">{{ 'м. ' + this.selectedLocationCity.name }}</b>
                        <!-- Новий дизайн: крапка стану поруч із містом — зелена пульсує (відчинено), червона (зачинено); текст — у підказці й для читалки -->
                        <i v-if="$v2" class="bp-hstatus__dot bp-hstatus__dot--m" :class="openStatus.open ? 'is-open' : 'is-closed'" role="img" :aria-label="openStatus.text" :title="openStatus.text"></i>
                    </div>
                </div>

                <div class="info-section-mobile">
                    <!-- Новий дизайн: перемикач теми одразу в шапці телефона, а не лише в меню під «бутербродом» -->
                    <button v-if="$v2" type="button" class="bp-mtheme" @click="changeMode()" v-html="$store.state.nightMode ? icons.sun : icons.moon"
                            :aria-label="$store.state.nightMode ? 'Увімкнути світлу тему' : 'Увімкнути темну тему'" :title="$store.state.nightMode ? 'Світла тема' : 'Темна тема'"></button>
                    <div style="margin-right: 14px" :class="{ 'bp-mphone': $v2 }">
                        <a :href="'tel:' + this.$store.state.phone" aria-label="Подзвонити">
                            <inline-svg src="/img/icons/phone-2.svg" width="30" height="30" :stroke="this.$store.state.nightMode ? 'white' : 'black'" @click="showInfomationModal('phone')"></inline-svg>
                        </a>
                    </div>

                    <div class="cart-section-mobile" :class="{ 'bp-bump': cartBump }" style="position: relative">
                        <router-link :to="{name: 'cart'}" :params="{ locationCity: this.$route.params.locationCity }" >
                            <inline-svg src="/img/icons/shopping-cart.svg" width="34" height="34"
                                        :fill="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                            <div v-if="$store.state.cart.length > 0" class="cart-badge">{{ $store.state.cart.length }}</div>
                        </router-link>
                    </div>
                </div>
            </div>
        </header>

        <div class="left-menu" @mouseover="mouseOverLeftMenu" @mouseleave="mouseLeaveLeftMenu">
            <div v-for="category in categories" :key="category.id"  v-if="category.is_enabled == 1 && !category.parent_id" class="left-menu-element" :class="{'is-active': ($route.name == 'category.index' && $route.params.code === category.code) || ($route.name == 'pizza' && category.id == 1)}" @click="routerToCategoryRoute('category.index', category.code)">
                <!-- Новий дизайн: контурна іконка категорії в колі (src/v2icons.js), підпис під колом -->
                <!-- Новий дизайн: у колі ті самі файли, що й у старому меню; активна — кольорова (-colored), решта — currentColor -->
                <div v-if="$v2" class="bp-cat-ic">
                    <inline-svg v-if="($route.name == 'category.index' && $route.params.code === category.code) || ($route.name == 'pizza' && category.id == 1)"
                                :key="category.code + '-on'" :src="'/img/icons/categories/' + category.code + '-colored.svg'" width="30" height="30" aria-hidden="true"
                                :transform-source="tintMonoIcon"></inline-svg>
                    <inline-svg v-else :key="category.code + '-off'" :src="'/img/icons/categories/' + category.code + '.svg'" width="30" height="30" fill="currentColor" aria-hidden="true"></inline-svg>
                </div>
                <div v-else>
                    <inline-svg v-if="($route.name == 'category.index' && $route.params.code === category.code) || ($route.name == 'pizza' && category.id == 1)" :src="'/img/icons/categories/' + category.code + '-colored.svg'" width="40" height="40"></inline-svg>

                    <inline-svg v-if="($route.name != 'category.index' && $route.name != 'pizza') || ($route.name == 'category.index' && $route.params.code !== category.code) || ($route.name == 'pizza' && category.id != 1)" :src="'/img/icons/categories/' + category.code + '.svg'" width="40" height="40"
                                :fill="$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                </div>
                <div class="left-menu-element-text">
                    {{ category.name }}
                </div>
            </div>
        </div>

        <!-- Новий дизайн, телефон: над нижнім меню — скільки в кошику, сума й «Оформити» (CSS ховає на комп'ютері) -->
        <transition name="bp-cartbar">
            <div v-if="showCartBar" class="bp-cartbar" role="region" aria-label="Кошик">
                <div class="bp-cartbar__info">{{ $store.getters.cartCount }} {{ cartCountWord }} · <span class="bp-cartbar__sum">{{ $store.getters.cartTotal }} грн</span></div>
                <router-link class="bp-cartbar__btn" :to="{name: 'cart', params: {locationCity: $route.params.locationCity}}"><inline-svg class="bp-btn-ic" src="/img/icons/shopping-cart.svg" width="20" height="20" fill="currentColor" aria-hidden="true"></inline-svg><span>Оформити</span></router-link>
            </div>
        </transition>

        <!-- Новий дизайн: «Вгору» — справа внизу основної колонки (ліворуч від кошика), на телефоні над нижнім меню й панеллю кошика -->
        <transition name="bp-totop">
            <button v-if="$v2 && showTop" type="button" class="bp-totop" aria-label="Вгору" title="Вгору" @click="toTop()" v-html="icons.arrowUp"></button>
        </transition>

        <div class="main-container" id="main-container">
            <!-- Новий дизайн: не працює лише доставка — смужка замість вікна, самовиніс доступний -->
            <div v-if="$v2 && $store.state.closed.delivery" class="bp-closed-strip" role="status">
                Доставка зараз не працює. Самовиніс — працює.
            </div>
            <div v-if="showBanner" class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <img src="@/assets/baner1_large.webp" class="slider-image">
                        <div class="slider-text-section">
                            <h1>
                                Наші переваги
                            </h1>
                            <div class="slider-text-box-description">
                                <div>
                                    Безкоштовна доставка
                                </div>
                                <div>
                                    Кешбек у мобільному додатку
                                </div>
                                <div>
                                    Фірмовий соус у подарунок
                                </div>
                                <div>
                                    Знижка 7% на самовиніс
                                </div>
                                <!-- Новий дизайн: без кнопки «Замовити» на слайдах -->
                                <div class="slide-text-box-button-section" v-if="!$v2">
                                    <a href="#main-content" v-smooth-scroll="{ offset: -80, updateHistory: false }">
                                        <button class="add-to-card-button">Замовити</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <img src="@/assets/baner2_large.webp" class="slider-image">
                        <div class="slider-text-section">
                            <h1>
                                Любиш поїсти?
                                Велика компанія?
                            </h1>
                            <div class="slider-text-box-description">
                                <div>
                                    Замовляй три піци –
                                    отримуй 50% знижки на четверту!
                                </div>
                                <div class="slide-text-box-button-section" v-if="!$v2">
                                    <a href="#main-content" v-smooth-scroll="{ offset: -80, updateHistory: false }">
                                        <button class="add-to-card-button">Замовити</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <img src="@/assets/baner3_large.webp" class="slider-image">
                        <div class="slider-text-section">
                            <h1>
                                Приємний бонус!
                            </h1>
                            <div class="slider-text-box-description">
                                <div>
                                    Купуй 2 або 3 піци –
                                    отримуй 1&nbsp;л напою у подарунок!
                                </div>
                                <div class="slide-text-box-button-section" v-if="!$v2">
                                    <a href="#main-content" v-smooth-scroll="{ offset: -80, updateHistory: false }">
                                        <button class="add-to-card-button">Замовити</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>

            <div style="padding: 14px;" id="main-content">
                <router-view/>
            </div>
            <!-- Новий дизайн: футер сіткою — бренд, контакти, посилання, застосунок і соцмережі; знизу смуга з копірайтом і оплатами -->
            <footer v-if="$v2" class="bp-footer">
                <div class="bp-footer__grid">
                    <div class="bp-footer__col">
                        <img v-if="$store.state.nightMode" src="@/assets/logo_site_white.webp" class="bp-footer__logo" alt="Black Pizza">
                        <img v-else src="@/assets/logo_site.webp" class="bp-footer__logo" alt="Black Pizza">
                        <div class="bp-footer__tag">Мабуть, найкраща піцерія у світі ;)</div>
                    </div>

                    <div class="bp-footer__col">
                        <div class="bp-footer__h">Контакти</div>
                        <button type="button" class="bp-footer__row bp-footer__row--addr" @click="showLocationCityModal()">
                            <span class="bp-footer__ic" v-html="icons.pin"></span><span>{{ $store.state.address }}</span>
                        </button>
                        <a class="bp-footer__row bp-footer__row--tel" :href="'tel:' + $store.state.phone">
                            <span class="bp-footer__ic" v-html="icons.phone"></span><span>{{ $store.state.phone }}</span>
                        </a>
                        <div class="bp-footer__row">
                            <span class="bp-footer__ic" v-html="icons.clock"></span><span>11:00–22:00</span>
                        </div>
                        <!-- Телефон: номер і «Маршрут» кнопками під контактами (рядок з номером тоді схований); на комп'ютері кнопок немає -->
                        <div class="bp-footer__acts">
                            <a class="bp-footer__act" :href="'tel:' + $store.state.phone" aria-label="Подзвонити"><span class="bp-footer__ic" v-html="icons.phone"></span>{{ $store.state.phone }}</a>
                            <a class="bp-footer__act" :href="'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent($store.state.address)" target="_blank" rel="noopener"><span class="bp-footer__ic" v-html="icons.pin"></span>Маршрут</a>
                        </div>
                    </div>

                    <nav class="bp-footer__col bp-footer__col--links" aria-label="Сторінки сайту">
                        <div class="bp-footer__h">Інформація</div>
                        <button type="button" class="bp-footer__link" @click="routerToRoute('pizza')">Головна</button>
                        <button type="button" class="bp-footer__link" @click="routerToRoute('delivery-map')">Мапа доставки</button>
                        <button type="button" class="bp-footer__link" @click="routerToRoute('about-us')">Про нас</button>
                        <button v-if="features.whoPays" type="button" class="bp-footer__link" @click="routerToRoute('who-pays')">Хто платить?</button>
                        <button type="button" class="bp-footer__link" @click="routerToRoute('offer')">Угода користувача</button>
                        <!-- «Співпраця» закрита з 03.11 -->
                    </nav>
                </div>

                <!-- Застосунок і соцмережі — одним рядком на всю ширину під колонками (04.11: у вузькій четвертій колонці
                     магазини, QR, кешбек і соцмережі стояли стовпчиком на 600 px). Вузьке вікно переносить групи -->
                <div class="bp-footer__app">
                    <div class="bp-footer__appgrp">
                        <div class="bp-footer__h">Завантажуй додаток</div>
                        <div class="bp-footer__apps">
                            <a href="https://apps.apple.com/cy/app/black-pizza/id1498371417" target="_blank" rel="nofollow" aria-label="App Store" onclick="dataLayer.push({'event': 'clickAppStore'});">
                                <img src="@/assets/appstore-badge-uk-black.svg" alt="Завантажити в App Store" class="bp-store-badge">
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=com.oakmont.blackpizza" target="_blank" rel="nofollow" aria-label="Google Play" onclick="dataLayer.push({'event': 'clickGooglePlay'});">
                                <img src="@/assets/googleplay-badge-uk.webp" alt="Завантажити з Google Play" class="bp-store-badge">
                            </a>
                        </div>
                        <!-- Комп'ютер: QR веде на /lutsk/application — та сторінка сама відкриває App Store чи Google Play за телефоном -->
                        <div class="bp-footer__qrbox">
                            <img src="@/assets/qr-app.svg" class="bp-footer__qr" alt="QR-код: завантажити застосунок">
                            <span>Наведіть камеру телефона, щоб завантажити</span>
                        </div>
                        <div class="bp-footer__perk"><span class="bp-footer__ic" v-html="icons.percent"></span>Кешбек у мобільному додатку</div>
                    </div>
                    <div class="bp-footer__appgrp bp-footer__appgrp--follow">
                        <div class="bp-footer__h">Слідкуй <span class="bp-footer__nobr">за нами</span></div>
                        <div class="bp-footer__social">
                            <!-- Офіційні монохромні знаки (src/v2icons.js, SOCIAL_ICONS) у тонкому колі 40 px, колір тексту -->
                            <a class="bp-social bp-social--youtube" href="https://youtube.com/@black_pizza" target="_blank" rel="nofollow" aria-label="YouTube" title="YouTube" v-html="socialIcons.youtube"></a>
                            <a class="bp-social bp-social--instagram" href="https://www.instagram.com/black_pizza/" target="_blank" rel="nofollow" aria-label="Instagram" title="Instagram" v-html="socialIcons.instagram"></a>
                            <a class="bp-social bp-social--tiktok" href="https://www.tiktok.com/@pizza_black" target="_blank" rel="nofollow" aria-label="TikTok" title="TikTok" v-html="socialIcons.tiktok"></a>
                        </div>
                    </div>
                </div>

                <div class="bp-footer__bottom">
                    <div class="bp-footer__copy">Усi права захищенi ©{{ new Date().getFullYear() }} Black Pizza®</div>
                    <div class="bp-footer__pay" aria-label="Оплата карткою">
                        <inline-svg src="/img/icons/master-card.svg" :fill="$store.state.nightMode ? 'white' : 'black'" aria-label="Mastercard"></inline-svg>
                        <inline-svg src="/img/icons/visa.svg" aria-label="Visa"></inline-svg>
                        <inline-svg src="/img/icons/liqpay.svg" :fill="$store.state.nightMode ? 'white' : 'black'" aria-label="LiqPay"></inline-svg>
                        <inline-svg src="/img/icons/privat.svg" aria-label="Приват24"></inline-svg>
                    </div>
                </div>
            </footer>
            <footer v-else class="footer">
                <div class="footer__column">
                    <img v-if="this.$store.state.nightMode" src="@/assets/logo_site_white.webp" style="width: 250px;">
                    <img v-if="!this.$store.state.nightMode" src="@/assets/logo_site.webp" style="width: 250px;">

                    <div class="footer__logo-text">
                        Мабуть, найкраща піцерія у світі ;)
                    </div>

                    <div class="footer__all-rights">
                        Усi права захищенi ©{{ new Date().getFullYear() }} Black Pizza®
                    </div>
                </div>

                <div class="footer__column">
                    <div style="margin-right: 14px" @click="showLocationCityModal()">
                        <inline-svg src="/img/icons/map-point.svg" width="25" height="25" stroke="#AB2321"></inline-svg>
                        <b style="margin-left: 4px">{{ this.$store.state.address }}</b>
                    </div>


                    <div style="margin-right: 14px;display: flex;">
                        <inline-svg src="/img/icons/phone-2.svg" width="25" height="25" stroke="#AB2321"></inline-svg>
                        <div style="margin-left: 7px;font-weight: bold;">{{ this.$store.state.phone }}</div>
                    </div>

                    <div style="display: flex;margin-right: 14px;">
                        <inline-svg src="/img/icons/clock.svg" width="25" height="25"
                                    fill="#AB2321"></inline-svg>
                        <div style="margin-left: 7px;">
                            <span style="font-weight: bold;">11:00-22:00</span>
                        </div>
                    </div>
                </div>

                <div class="footer__column">
                    <ul style="list-style: none;padding: 0;font-weight: bold;margin-bottom: 0">
                        <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('pizza')">Головна</li>
                        <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('delivery-map')">Мапа доставки</li>
                        <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('about-us')">Про нас</li>
                        <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('offer')">Угода
                            користувача
                        </li>
                        <!-- «Співпраця» закрита з 03.11 -->
                    </ul>
                </div>
                <div class="footer__column footer__mob-row">
                    <inline-svg src="/img/icons/master-card.svg" width="40" height="40" :fill="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                    <inline-svg src="/img/icons/visa.svg" width="45" height="45"></inline-svg>
                    <inline-svg src="/img/icons/liqpay.svg" width="80" height="26" :fill="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                    <inline-svg src="/img/icons/privat.svg" width="26" height="26"></inline-svg>
                </div>

                <div class="footer__column">
                    <div class="footer__row-title">
                        Завантажуй додаток:
                    </div>
                    <div class="footer__row">
                        <a href="https://apps.apple.com/cy/app/black-pizza/id1498371417" target="_blank" rel="nofollow" aria-label="App Store" onclick="dataLayer.push({'event': 'clickAppStore'});">
                            <img src="@/assets/appstore.webp" style="width: 120px; height: 38px" alt="App Store" title="App Store">
                        </a>

                        <a href="https://play.google.com/store/apps/details?id=com.oakmont.blackpizza" target="_blank" rel="nofollow" aria-label="Google Play" onclick="dataLayer.push({'event': 'clickGooglePlay'});">
                            <img src="@/assets/googleplay.webp" style="width: 120px; height: 38px" alt="Google Play" title="Google Play">
                        </a>
                    </div>
                    <div class="footer__row-title">
                        Слідкуй за нами:
                    </div>
                    <div class="footer__row">
                        <a href="https://youtube.com/@black_pizza" target="_blank" rel="nofollow" aria-label="Youtube">
                            <img src="@/assets/youtube-circle.svg" style="width: 40px;" alt="Youtube" title="Youtube">
                        </a>
                        <a href="https://www.instagram.com/black_pizza/" target="_blank" rel="nofollow" aria-label="Instagram">
                            <img src="@/assets/instagram-circle.svg" style="width: 40px;" alt="Instagram" title="Instagram">
                        </a>
                        <a href="https://www.tiktok.com/@pizza_black" target="_blank" rel="nofollow" aria-label="TikTok">
                            <img src="@/assets/tik-tok-cricle.svg" style="width: 40px;" alt="TikTok" title="TikTok">
                        </a>
                    </div>
                </div>
            </footer>
        </div>

        <!-- На інформаційних сторінках (noCartPanel) панель лише ховаємо, а не прибираємо: введене у формі кошика лишається -->
        <div v-show="!noCartPanel" class="cart">
            <Cart/>
        </div>
    </div>
</template>

<script>
import Cart from '@/views/Cart.vue'
import InfoModal from '@/components/InfoModal.vue'
import ClosedSign from '@/components/ClosedSign.vue'
import LocationCityModal from '@/components/LocationCityModal.vue'
import Swiper from 'swiper'
import InlineSvg from 'vue-inline-svg';
import axios from 'axios'
import Product from "@/components/Product.vue";
import { ICONS, SOCIAL_ICONS } from '@/v2icons';
import { V2_FEATURES } from '@/v2features';
import { isOpenNow } from '@/workHours';

// Чи є в тексті хоч одне слово (а не лише «)» чи «))»)
const hasWords = t => /[A-Za-zА-Яа-яЇїІіЄєҐґ]{2}/.test(t || '');

export default {
    components: {
        Product,
        LocationCityModal,
        Cart,
        InfoModal,
        ClosedSign,
        InlineSvg
    },
    data() {
        return {
            nowTick: Date.now(), // новий дизайн: «Відчинено до 22:00» у шапці перераховується щохвилини
            showInfoModal: false,
            showClosedSign: false,
            isShowLocationCityModal: false,
            infoModalText: '',
            locationCities: [],
            isApplication: false,
            applicationType: '',
            applicationURL: '',
            categories: [],
            selectedLocationCity: {
                name: ''
            },
            mobNav: false,
            icons: ICONS,
            features: V2_FEATURES,
            socialIcons: SOCIAL_ICONS,
            showTop: false,
            // Новий дизайн: значок кошика в шапці коротко «підстрибує», коли товар додано
            cartBump: false,
            cartBumpTimer: null
        }
    },

    watch: {
        '$store.getters.cartCount'(count, before) {
            if (!this.$v2 || !(count > before)) {
                return;
            }
            // Знімаємо клас і ставимо в наступному кадрі, щоб анімація почалась знову при швидкому додаванні
            clearTimeout(this.cartBumpTimer);
            this.cartBump = false;
            requestAnimationFrame(() => {
                this.cartBump = true;
                this.cartBumpTimer = setTimeout(() => {
                    this.cartBump = false;
                }, 300);
            });
        }
    },

    computed: {
        // Стан у шапці за київським часом: години 11:00–22:00 (ті самі, що в підвалі); вимикачі з адмінки мають перевагу
        openStatus() {
            const closed = this.$store.state.closed;
            if (!isOpenNow(closed, new Date(this.nowTick))) return { open: false, word: 'Зачинено', text: 'Зачинено · працюємо 11:00–22:00' };
            return closed.delivery
                ? { open: true, word: 'Лише самовиніс', text: 'Працюємо, лише самовиніс · до 22:00' }
                : { open: true, word: 'Працюємо', text: 'Працюємо · до 22:00' };
        },
        // Банер: у новому дизайні — над усім меню (адреса під час гортання міняється, банер лишається)
        showBanner() {
            if (this.$v2) {
                return this.$route.name == 'pizza' || this.$route.name == 'category.index';
            }
            return this.$route.name == 'pizza' || (this.$route.name == 'category.index' && this.$route.params.code == 'pizza');
        },

        // Панель кошика (новий дизайн): коли в кошику щось є і ми не на сторінці кошика
        showCartBar() {
            return this.$v2 && this.$store.getters.cartCount > 0 && this.$route.name != 'cart';
        },

        // Новий дизайн: «Мапа доставки», «Про нас» і «Угода» — без бокової панелі кошика, сторінка на всю ширину
        noCartPanel() {
            return this.$v2 && ['delivery-map', 'about-us', 'offer'].includes(this.$route.name);
        },

        // 1 товар, 2 товари, 5 товарів, 21 товар, 12 товарів
        cartCountWord() {
            const n = this.$store.getters.cartCount;
            const last = n % 10, lastTwo = n % 100;
            if (last == 1 && lastTwo != 11) return 'товар';
            if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) return 'товари';
            return 'товарів';
        },

        // Заголовок і текст вікна з «Налаштувань»; якщо там лише розділові знаки («))»), — звичайні слова
        closedTitle() {
            const t = this.$store.state.closed.title;
            return hasWords(t) ? t : 'Зараз ми зачинені';
        },
        closedText() {
            const t = this.$store.state.closed.text;
            return hasWords(t) ? t : 'Замовлення тимчасово не приймаємо. Меню можна переглянути.';
        }
    },

    methods: {
        // Новий дизайн: «-colored.svg» без жодного кольору (other-colored.svg — ті самі контури, що other.svg, без fill)
        // інакше лишається чорним; фарбуємо його кольором активної категорії (currentColor)
        tintMonoIcon(svg) {
            if (!svg.querySelector('[fill]:not([fill="none"]), [style*="fill"]')) {
                Array.prototype.forEach.call(svg.children, el => el.setAttribute('fill', 'currentColor'));
            }
            return svg;
        },
        // Новий дизайн: кнопка «Вгору» — коли прогорнули приблизно на екран
        onScrollTop() {
            this.showTop = window.pageYOffset > window.innerHeight * 0.9;
        },

        toTop() {
            const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        },

        mouseOverLeftMenu() {
            // Новий дизайн: підписи під колами видно завжди — панель не розгортається і не затемнює сторінку
            if (this.$v2 || window.innerWidth <= 1024) {
                return;
            }
            let mainOverlay = this.$refs['main-overlay'];
            mainOverlay.style.display = 'block';
        },

        mouseLeaveLeftMenu() {
            let mainOverlay = this.$refs['main-overlay'];
            mainOverlay.style.display = 'none';
        },

        routerToRoute(name) {
            if(this.mobNav) {
                this.closeMobNav();
            }
            this.$router.push({name: name, params: {location_city: this.$route.params.locationCity}});
        },

        routerToCategoryRoute(name, code) {
            if(this.mobNav) {
                this.closeMobNav();
            }
            // Новий дизайн: меню одним гортанням — на ньому клік лише гортає до секції (views/Menu.vue)
            if (this.$v2 && (this.$route.name == 'pizza' || this.$route.name == 'category.index')) {
                this.$root.$emit('bp-menu-go', code);
                return;
            }
            this.$router.push({name: name, params: {location_city: this.$route.params.locationCity, code: code}});
        },

        showInfomationModal(type) {
            this.isApplication = false;
            if (type == 'phone') {
                dataLayer.push({
                    'event': 'clickPhone'
                });
                this.infoModalText = 'Телефон: ' + this.$store.state.phone;
            }
            if (type == 'address') {
                this.infoModalText = 'адреса: <span style="font-weight: bold;">' + this.$store.state.address + '</span>';
            }
            if (type == 'time') {
                this.infoModalText = 'Графік роботи: <span style="font-weight: bold;">11:00-22:00</span>';
            }
            window.scrollTo(0, 0);
            document.querySelector('body').style.overflow = 'hidden';
            this.showInfoModal = true;
        },

        closeInfomationModal() {
            document.querySelector('body').style.overflow = '';
            this.showInfoModal = false;
        },

        changeMode() {
            // Від поточної теми, а не від збереженої: у новому дизайні тема могла прийти із системи без запису в localStorage
            let newMode = this.$store.state.nightMode ? 0 : 1;
            localStorage.setItem('nightmode', newMode);
            this.applyMode(newMode);
        },

        applyMode(mode) {
            this.$store.commit('setMode', mode);
            document.querySelector('body').style.backgroundColor = mode ? '#1c1a1a' : '';
        },

        showLocationCityModal() {
            if(this.locationCities && this.locationCities.length > 1) {
                this.isShowLocationCityModal = true;
            }
        },

        closeLocationCityModal() {
            document.querySelector('body').style.overflow = '';
            this.isShowLocationCityModal = false;
        },

        changeLocationCity(locationCityId) {
            if(locationCityId != localStorage.getItem('locationCityId')) {
                localStorage.setItem('cart', JSON.stringify([]));
            }

            localStorage.setItem('locationCityId', locationCityId);
            this.$store.commit('setLocationCityId', locationCityId);

            if(locationCityId == 1) {
                this.openCity('/lutsk');
            }
            else if(locationCityId == 2) {
                this.openCity('/kyiv');
            }

            this.selectedLocationCity = this.$store.state.locationCities.filter(locationCity => {
                return locationCity.id == locationCityId
            });
            this.selectedLocationCity = this.selectedLocationCity.length > 0 ? this.selectedLocationCity[0] : this.$store.state.locationCities[0];

            let defaultLocation = this.selectedLocationCity.locations.filter(location => {
                return location.is_default == 1
            });

            defaultLocation = defaultLocation.length > 0 ? defaultLocation[0] : this.selectedLocationCity.locations[0];

            this.$store.commit('setPhone', this.selectedLocationCity.phone);
            this.$store.commit('setAddress', 'м. ' + this.selectedLocationCity.name + ', вул. ' + defaultLocation.name);
        },

        // Сторінка міста з повним перезавантаженням. У демо-збірці (адреси #/…) replace міняє лише хеш, тому ще й reload
        openCity(path) {
            window.location.replace(this.$router.resolve(path).href);
            if (this.$router.mode === 'hash') window.location.reload();
        },

        showMobNav() {
            this.mobNav = true;
        },

        closeMobNav() {
            document.querySelector('body').style.overflow = '';
            this.mobNav = false;
        },
    },

    beforeCreate() {
        let locationCityId = null;
        if(this.$route.params.locationCity == 'lutsk') {
            locationCityId = 1;
        }
        else if(this.$route.params.locationCity == 'kyiv') {
            locationCityId = 2;
        }

        localStorage.setItem('locationCityId', locationCityId);
        this.selectedLocationCity = locationCityId;
        this.$store.commit('setLocationCityId', locationCityId);
        this.$store.dispatch('getLocationCities').then(locationCities => {
            this.locationCities = locationCities;

            this.selectedLocationCity = this.$store.state.locationCities.filter(locationCity => {
                return locationCity.id == localStorage.getItem('locationCityId');
            });
            this.selectedLocationCity = this.selectedLocationCity.length > 0 ? this.selectedLocationCity[0] : this.$store.state.locationCities[0];

            let defaultLocation = this.selectedLocationCity.locations.filter(location => {
                return location.is_default == 1
            });

            defaultLocation = defaultLocation.length > 0 ? defaultLocation[0] : this.selectedLocationCity.locations[0];

            this.$store.commit('setPhone', this.selectedLocationCity.phone);
            this.$store.commit('setAddress', 'м. ' + this.selectedLocationCity.name + ', вул. ' + defaultLocation.name);
        });

        this.$store.dispatch('getCategories').then(categories => {
            this.categories = categories;
            console.log(this.categories);
        });
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.onScrollTop);
        clearInterval(this.nowTimer);
        if (this.onSystemTheme) this.themeQuery.removeEventListener('change', this.onSystemTheme);
    },

    mounted() {
        if (this.$v2) {
            window.addEventListener('scroll', this.onScrollTop, { passive: true });
            this.onScrollTop();
            this.nowTimer = setInterval(() => { this.nowTick = Date.now(); }, 60000);
            // Тема як у системі, доки людина сама не перемкнула: телефон увечері переходить на темну — сайт теж
            this.themeQuery = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
            if (this.themeQuery && this.themeQuery.addEventListener) {
                this.onSystemTheme = e => { if (localStorage.getItem('nightmode') === null) this.applyMode(e.matches ? 1 : 0); };
                this.themeQuery.addEventListener('change', this.onSystemTheme);
            }
        }
        axios.get(`https://api.pizza.black/api/${JSON.parse(localStorage.getItem('locationCityId'))}/settings`).then(response => {
            const settings = response.data;
            this.$store.commit('setClosed', {
                all: settings.is_closed == 1,
                delivery: settings.is_closed != 1 && settings.is_closed_delivery == 1,
                title: settings.closed_title || '',
                text: settings.closed_description || ''
            });
            if (this.$v2 && settings.is_closed == 1) {
                this.showClosedSign = true;
            } else if (!this.$v2 && (settings.is_closed == 1 || settings.is_closed_delivery == 1)) {
                this.infoModalText = `${settings.closed_title}<br>${settings.closed_description}`;
                this.showInfoModal = true;
            } else {
                if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPad/i))) {
                    this.isApplication = true;
                    this.applicationType = 'ios';
                    this.applicationURL = 'https://apps.apple.com/cy/app/black-pizza/id1498371417';
                    this.showInfoModal = true;
                }

                if ((navigator.userAgent.match(/Android/i))) {
                    this.isApplication = true;
                    this.applicationType = 'android';
                    this.applicationURL = 'https://play.google.com/store/apps/details?id=com.oakmont.blackpizza';
                    this.showInfoModal = true;
                }
            }
        });

        if (this.$store.state.nightMode) {
            document.querySelector('body').style.backgroundColor = '#1c1a1a';
        }

        var mySwiper = new Swiper('.swiper-container', {
            // If we need pagination
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },

            autoplay: {
                stopOnLastSlide: true
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        });

        // Новий дизайн: на сторінці без банера (кошик, «Про нас»…) Swiper без автогортання — без помилки в консолі
        if (this.$v2 && !mySwiper.autoplay) {
            return;
        }
        mySwiper.autoplay.start();
    }
}
</script>

<style>
/* Новий дизайн: не працює лише доставка */
.bp-v2 .bp-closed-strip { margin: 0 0 16px; padding: 12px 16px; border-radius: var(--bp-r-card); background: #fff4d6; border: 1px solid #ecd28a; color: #5c4400; font-weight: 600; font-size: 15px; line-height: 20px; }
.bp-v2 .dark .bp-closed-strip, .bp-v2 #app.dark .bp-closed-strip { background: #3a3015; border-color: #6b5a24; color: #ffe7a3; }
</style>
